import React, { useEffect, useState, useRef } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
// import "../PagesStyles/AdminMasters.css";
import style from "./CustomerRateOfInterestNew.module.css";
import RateOfInterestTable from "Components/support/customervendor/RateOfInterestTable";
import { Icon } from "@iconify/react";
import { TbCircleNumber1 } from "react-icons/tb";
import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a18,
  a207,
  a208,
  a209,
  a210,
  a211,
  a212,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import toast from "react-hot-toast";
import { use } from "react";
export default function CustomerRateOfInterestNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);

  const [allCategories, setAllCategories] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  
  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };
  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };
const inputRef = useRef();

  const [newCategory, setNewCategory] = useState({
    RateOfInterest: "",
    
    ClientCode: "",
    CompanyId: 0,
    CounterId: 0,
    BranchId: 0,
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a210, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);
  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  console.log(allDepartmentsList, "allDepartmentsList");
  console.log(allBranchesList, "allBranchesList");
  console.log(allRolesList, "allRolesList");

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      RateOfInterest: newCategory.RateOfInterest,

      CompanyId: CompanyId ? CompanyId : 0,
      CounterId: CounterId ? CounterId : 0,
      BranchId: BranchId ? BranchId : 0,
     OldEntry: false,
     ...(newCategory.OldEntry ? { Id: Number(newCategory.Id) } : {}),
    };
    console.log(formData, "formData to send");
    console.log(newCategory.Id);
    console.log(newCategory.OldEntry);
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a211 : a212,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        RateOfInterest: "",
        ClientCode: "",
        
        CompanyId: 0,
        CounterId: 0,
        BranchId: 0,
        OldEntry: false,
      });
      if (data.message) {
        // alert(data.message);
        // setMessageType("error");
        toast.error(data.message,{
          duration : 3000,
          position: 'top-center'
        });
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Rate Of Interest Added Successfully",{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    console.log(data, "data");
    console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true, Id:data?.Id });
    setActive("AddNew");
  };
 
  useEffect(() =>{
    console.log('newCategory', newCategory);
    
  },[newCategory])

  const handlenew = () => {
    setActive("AddNew");
  };
  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Customer Rate Of Interest"}
          companyName={"Loyalstring"}
          module={"Settings"}
          page={"Customer Rate Of Interest"}
        />
        {active == "List" ? (
          <>
            <div style={{ padding: "16px" }}>
            <div className={style["white-space"]}>
               

                <div className={style["icon-div"]}>
                  <div className={style["search-container"]}>
                    <input
                      type="text"
                      value={searchInput}
                      onChange={handleSearchChange}
                      placeholder="Search..."
                      className={style["serach-input"]}
                    />
                    <button
                      style={{ margin: 0 }}
                      className={style["search-btn"]}
                      // onClick={handleSearchSubmit}
                    >
                      <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                    </button>
                  </div>
                  
                  <Icon
                  
                    style={{
                      fontSize: "28px ",
                      color: "#0077d4",
                      cursor: "pointer",
                    }}
                    icon="bx:export"
                  />
                  
                 
                  <button
                    // style={{ width: "30%" }}
                    className={style["custom-btn"]}
                  >
                    <Icon
                      style={{ fontSize: "24px " }}
                      icon="ic:outline-print"
                    />
                    Print
                  </button>
                  <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                  New
                  <Icon icon="mdi:plus" width="24" height="24" />
                </button>
                </div>
              </div>

              <RateOfInterestTable
                // columns={columns}
                allCategories={allCategories}
                handleEditData={handleEditData}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
              />
            </div>
          </>
        ) : (
          <>
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className="adminAddCategoryInnerBoxTitlesBox">
                  <div>
                    {/* <p>Add New Customer Rate Of Interest</p> */}
                    <form onSubmit={addNewCategory}>
                      <div
                        style={{
                          gridTemplateColumns: "repeat(4,1fr)",
                          columnGap: "40px",
                          minHeight: "50px",
                          marginTop: "30px",
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>
                          Rate Of Interest %<sup>*</sup>
                        </label>
                        <input
                          ref={inputRef} 
                          name="RateOfInterest"
                          value={newCategory.RateOfInterest}
                          onChange={handleNewCategoryChange}
                          type="number"
                          max="100"
                          required="required"
                        />
                      </div>
                      {!loading ? (
                        <div
                          style={{ marginBottom: "20px" }}
                          className={style["btn-container"]}
                        >
                          <button style={{ marginTop: "20px" }}>
                            <Icon width="24px" icon="ic:sharp-check" /> Submit
                          </button>
                          <button
                        onClick={() => {
                        
                            // Resetting the input field value to an empty string
                            setNewCategory({ RateOfInterest: "" });
                            // Optionally, you can also clear the input field visually by accessing the DOM directly using useRef
                            inputRef.current.value = "";
                    
                        }}
                        style={{
                          marginTop: "20px",
                           display: "flex",
                           height: "32px",
                           justifyContent: "center",
                           alignItems: "center",
                           borderRadius: "5px",
                           background: "#fff",
                           color: "#0077d4",
                           border: "1px solid #0077d4",
                           cursor: "pointer"
                        }}>
                          <Icon
                            width="24px"
                            icon="ix:reset"
                            style={{ color: "#0077D4" }}
                          />{" "}
                          Reset
                        </button>
                          <button
                            style={{ marginTop: "20px" }}
                            onClick={() => {
                              setActive("List");
                            }}
                          >
                            <Icon
                              width="24px"
                              icon="fluent:list-rtl-16-filled"
                            />{" "}
                            List
                          </button>
                        </div>
                      ) : null}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
